(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineDialogController', MachineDialogController);

    MachineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Machine', 'SiteLocation'];

    function MachineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Machine, SiteLocation) {
        var vm = this;

        vm.machine = entity;
        vm.clear = clear;
        vm.save = save;
        vm.siteLocations  =  SiteLocation.getAllByClinic({id: vm.machine.clinic.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.machine.id !== null) {
                Machine.update(vm.machine, onSaveSuccess, onSaveError);
            } else {
                Machine.save(vm.machine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:machineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
